import { fireTrack } from "@swa-ui/analytics";
import { swaDate } from "@swa-ui/date";

export const fireBookingWidgetAnalytics = (tabName) => {
  fireTrack("squid", { page_description: `paneldisplayed:${tabName}` });
};

export const fireClearSearchesLinkAnalytics = () => {
  fireTrack("squid", { page_description: "link:clear searches" });
};

export const fireDestinationOffersAnalytics = (offerDetails = {}) => {
  const { destination = "", lfmaPrice = "", origin = "" } = offerDetails;

  fireTrack("squid", {
    page_description: "click:destination offers",
    track_moduledetail: `destinationOffers;${origin};${destination};${lfmaPrice}`,
  });
};

export const fireDestinationOffersByThemeAnalytics = (station) => {
  fireTrack("squid", {
    page_description: "click:destination themes",
    track_moduledetail: `destinationThemes;;${station};`,
  });
};

export const fireFindVacationAnalytics = () => {
  fireTrack("squid", { page_description: "button:LandingPage-Search" });
};

export const fireSpecialOffersAnalytics = () => {
  fireTrack("squid", { page_description: "chevron click:special offers" });
};

export const fireStopRememberingLinkAnalytics = () => {
  fireTrack("squid", { page_description: "link:stop remembering" });
};

export const fireUpcomingTripsCardAnalytics = (upcomingTrips, upcomingTripsButton, seatLabel) => {
  const {
    pnr_type: pnrType,
    pnr_sub_type: pnrSubType,
    upcoming_travel_at,
  } = upcomingTrips?.[0] ?? [];
  let upcomingTripsLabel = upcomingTripsButton || seatLabel;

  if (upcomingTripsButton && seatLabel) {
    upcomingTripsLabel = [upcomingTripsButton, seatLabel].join("|");
  }

  upcomingTrips?.length > 0 &&
    fireTrack("squid", {
      banner_upcomingtrips: "1",
      customer_daystotrip: daysUntilNextFlight(upcoming_travel_at),
      page_description: "banner:upcoming trips",
      pnr_origin: `${pnrType}|${pnrSubType}`,
      upcomingtrips_button: upcomingTripsLabel,
      upcomingtrips_count: `${upcomingTrips.length}`,
    });
};

export const fireDestinationInfoIconClickAnalytics = () => {
  fireTrack("squid", { page_description: "icon:keywordsearch", widget_keywordsearch: "1" });
};

export const fireDestinationToolTipSelectAnalytics = (destination) => {
  fireTrack("squid", {
    page_description: "keywordsearch:keyword",
    keywordsearched: `${destination}`,
  });
};

function daysUntilNextFlight(upcoming_travel_at) {
  const daysRemaining = Math.floor(swaDate(upcoming_travel_at).diff(swaDate(), "days"));
  let result = "";

  if (daysRemaining === 0) {
    result = "zero";
  } else {
    result = daysRemaining > 0 ? daysRemaining.toString() : "";
  }

  return result;
}
